import { memo } from 'react';
import { ProfileEditMailAddressConfirmTemplate } from 'components/templates/ProfileEditMailAddressConfirmTemplate';

type Props = {};

export const ProfileEditMailAddressConfirmPage = memo((_props: Props) => {
	return <ProfileEditMailAddressConfirmTemplate />;
});
